var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FlyerlineModal",
    {
      ref: "modal",
      attrs: { name: "addressBookUpdateAddress" },
      on: { close: _vm.handleClose },
    },
    [
      _vm.addresskey
        ? _c("SkyFormLoader", {
            key: _vm.addresskey,
            attrs: {
              formName: "prj_shopupdateaddress",
              params: {
                shop_addressKey: _vm.addresskey,
                shop_addressKeyType: 2,
              },
            },
            on: { success: _vm.handleConfirm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }